import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import Close from '@images/svg/ui/close.svg';

const MediaThumbnail = forwardRef(({ onRemove, src, alt }, ref) => {
  const [removed, setRemoved] = useState(false);
  const handleRemove = event => {
    event.stopPropagation();
    event.preventDefault();
    setRemoved(true);
    setTimeout(onRemove, 300);
  };
  return (
    <div className={`c-media-thumbnail ${removed ? 'c-media-thumbnail--removed' : ''}`} ref={ref}>
      <button title='Entfernen' onClick={handleRemove} className='c-media-thumbnail__remove'>
        <Close />
      </button>
      <img src={src} alt={alt} className='c-media-thumbnail__image' />
    </div>
  );
});

MediaThumbnail.displayName = 'MediaThumbnail';

MediaThumbnail.propTypes = {
  onRemove: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string
};

export default MediaThumbnail;
